import { render, staticRenderFns } from "./ForceResetPasswordModal.vue?vue&type=template&id=0747ba1c&scoped=true"
import script from "./ForceResetPasswordModal.vue?vue&type=script&lang=js"
export * from "./ForceResetPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./ForceResetPasswordModal.vue?vue&type=style&index=0&id=0747ba1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0747ba1c",
  null
  
)

export default component.exports